const config = {
    host: (process.env.NODE_ENV === 'production') ? 'https://coco.dvgeo.app' : 'http://192.168.100.106:3038',
    homePage: (process.env.NODE_ENV === 'production') ? 'https://coco.dvgeo.app' : 'http://192.168.100.106:3038',
    api: 'api/',
    apiSocket: 'coco::1.2',
    nameDir: 'coco',
    package: 'ec.coco.web',
    version: '1.0.0',
    googleAPIKey: 'AIzaSyAy2lm4Y0qPOzhiN05gciB8ObXL2At1ezM',
    appName: 'COCO',
    provider: '',
    colorPrimary: '#98c602',
    colorDark: '#2d2829',
    colorAccent: '#ccc',
    colorTextPrimary: '#fff',
    colorTextDark: '#000',
    playStorePassengerId: 'ec.coco.passenger',
    playStoreDriverId: 'ec.coco.driver',
    appStorePassengerId: '6783487821',
    appStoreDriverId: '6783487507',
};
export default config;
